import React from 'react'

function KzIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_11556_74303)">
        <mask id="mask0_11556_74303" maskUnits="userSpaceOnUse" x="8" y="8" width="18" height="18">
          <rect x="8" y="8" width="18" height="18" rx="3" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_11556_74303)">
          <rect x="8" y="8" width="18" height="18" fill="#3AD2E7" />
          <circle cx="17" cy="17" r="4" fill="#FFEC2D" />
          <circle cx="17" cy="17" r="5.5" stroke="#FFEC2D" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_11556_74303"
          x="0"
          y="0"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11556_74303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11556_74303" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default KzIcon
